import styled from "styled-components";

export const ControlPanelStyle = styled.div`
  width: 100%;
  padding: 1rem 0;
  display: flex;
  justify-content: center;
`;